import React, { useEffect, useState } from 'react';
import "./RecordFormClinics.scss"

import Dropdown from '../../../UI/Dropdown/Dropdown'

import { useSelector } from 'react-redux';

const RecordFormClinics = ({selectHandler = null, selectedClinic = null}) => {
	const clinic = useSelector(state => state.recordsTable.clinic)
	const clinics = useSelector(state => state.clinics.clinics)
	const [defaultClinic, setDefaultClinic] = useState(null)

	useEffect(() => {
		if(!selectedClinic) setDefaultClinic(clinics.find((el) => Number(el.id) === Number(clinic)))
	}, [clinic])

	useEffect(() => {
		if(selectedClinic && clinics){
			const clinic = clinics.find((el) => Number(el.id) === Number(selectedClinic))
			if(clinic) setDefaultClinic(clinic)
		}
	}, [clinics, selectedClinic])

	return (
		<div className="record-form-clinics">
			{
				defaultClinic &&
				<Dropdown
					optionsList={clinics}
					optionSelected={defaultClinic}
					type='clinics'
					label='Салон'
					selectedHandler={selectHandler}/>
			}
		</div>
	);
};

export default RecordFormClinics;
